import { Component, OnInit } from '@angular/core';
import { IdP } from '../models/idp';
import { Alert } from '../shared/alert';
import { AppTitle } from '../shared/title';
import { ActivatedRoute, Router } from '@angular/router';
import { IdentityService } from '../services/identity.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DropdownOption } from '../shared/dropdown_option';
import { FindIdP } from '../models/find_idp';
import { controlErrors } from '../shared/app.validators';
import { IdPRolesMapping } from '../models/idp_roles_mapping';
import { IdPRolesMappingRequest } from '../models/idp_roles_mapping_request';
import { FindIdPRolesMapping } from '../models/find_idp_roles_mapping';
import { FindAccountAssociation } from '../models/find_account_association';
import { AccountAssociation } from '../models/account_association';
import { UserRoles } from '../models/user_roles';
import { User } from '../models/user';
import { Account } from '../services/account.service';

class CheckboxRoleValue {
    title: string;
    value: boolean;

    constructor() {
        this.title = '';
        this.value = false;
    }
}

@Component({
  selector: 'app-idp-add-edit',
  template: `
    <div class="row" [hidden]="msgHead.msg == ''">
        <div class="col-lg-8 col-md-6 col-xs-12">
            <alert [alert]="msgHead"></alert>
        </div>
    </div>
    <div *ngIf="hasAccess" class="row">
        <div class="col-lg-12 col-md-12 col-xs-12" style="padding:0px; margin-bottom:0px;">
            <form [formGroup]="form" novalid>
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-xs-12" style="margin-bottom: 0px;">

                        <div class="form-group">
                            <p class="custom-label">Identity Providers</p>
                            <select formControlName="idpId" class="form-control" title="Identity Provider">
                                <option *ngFor="let idp of idps; let i = index" [value]="idp.id">{{idp.title}}</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <p class="custom-label">Service</p>
                            <select [(ngModel)]="data.serviceId" formControlName="serviceId" (change)="displayServiceRoles()" class="form-control" title="Service">
                                <option *ngFor="let svc of services; let i = index" [value]="svc.id">{{svc.title}}</option>
                            </select>
                        </div>

                        <div *ngIf="!hideOrgInput" class="form-group">
                            <p class="custom-label">Organization</p>
                            <select formControlName="orgAcctNumber" class="form-control" title="Organization">
                                <option *ngFor="let org of orgs; let i = index" [value]="org.id">{{org.title}}</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <p class="custom-label">Organization Mapping (comma separated)</p>
                            <input type="text" [(ngModel)]="data.accountGroups" formControlName="accountGroups" class="form-control" placeholder="Organization Mapping" title="Organization Mapping">
                        </div>

                        <div class="form-group">
                            <p class="custom-label">Service Roles</p>
                            <div *ngFor="let role of serviceRoles" class="checkbox">
                                <label>
                                    <input [(ngModel)]="role.value" type="checkbox" [ngModelOptions]="{standalone: true}"> {{ role.title }}
                                </label>
                            </div>
                        </div>

                        <div class="form-group">
                            <p class="custom-label">Service Roles Mapping (comma separated)</p>
                            <input type="text" [(ngModel)]="data.serviceRolesGroups" formControlName="serviceRolesGroups" class="form-control" placeholder="Service Roles Mapping" title="Service Roles Mapping">
                        </div>

                    </div>
                </div>
            </form>
        </div>
        <div class="col-lg-12 col-md-12 col-xs-12" style="margin-top:0px;">
            <button type="button" class="btn btn-large btn-primary" (click)="save()">Save</button>
            <a style="margin-left:10px;cursor: pointer;" (click)="goBack()">Go Back</a>
        </div>
    </div>
    <div *ngIf="hasAccess" class="row">
        <div class="col-lg-6 col-md-6 col-xs-12">
            <alert [alert]="msg" style="display:block;"></alert>
        </div>
    </div>
  `,
})
export class AddEditRolesMappingComponent implements OnInit {
    data: IdPRolesMappingRequest;
    msg: Alert;
    msgHead: Alert;
    acctNumber: string;
    hasAccess: boolean;
    form: FormGroup;
    idps: DropdownOption[];
    services: DropdownOption[];
    orgs: DropdownOption[];
    idParam: string;
    editMode: boolean;
    schoolManagerRoles: CheckboxRoleValue[];
    districtMangerRoles: CheckboxRoleValue[];
    identityRoles: CheckboxRoleValue[];
    serviceRoles: CheckboxRoleValue[];
    adminRoles: CheckboxRoleValue[];
    hideOrgInput: boolean;

    constructor(private title: AppTitle, private activatedRoute: ActivatedRoute, private idsvc: IdentityService, private router: Router, fb: FormBuilder, private accsvc: Account) {
        this.hasAccess = true;
        this.msg = new Alert();
        this.msgHead = new Alert();
        this.editMode = false;
        this.data = new IdPRolesMappingRequest();
        this.idps = [];
        this.orgs = [];
        this.idps.push({ id: '', title: 'Select Identity Provider' });
        this.orgs.push({ id: '', title: 'Select Organization' });
        this.form = fb.group({
			idpId: ['', Validators.compose([Validators.required])],
			serviceId: ['', Validators.compose([Validators.required])],
			orgAcctNumber: ['', Validators.compose([Validators.required])],
			accountGroups: ['', Validators.compose([Validators.required])],
			serviceRolesGroups: ['', Validators.compose([Validators.required])],
        });
        this.hideOrgInput = false;

        this.schoolManagerRoles = [
            { title: 'admin', value: false },
            { title: 'user', value: false },
            { title: 'director', value: false },
            { title: 'notification', value: false },
            { title: 'station-kiosk', value: false }
        ];
		this.districtMangerRoles = [
            { title: 'admin', value: false },
            { title: 'user', value: false },
            { title: 'one-roster', value: false }
        ];
        this.identityRoles = [
            { title: 'admin', value: false },
        ];
        this.adminRoles = [
            { title: 'admin', value: false },
        ];
        this.services = [
            { id: '', title: 'Select Service' },
            { id: 'school', title: 'School Manager' },
            { id: 'district', title: 'District Manager' },
            { id: 'identity', title: 'Identity' },
        ];

        let currentUser: User = this.accsvc.getUser();
        if (currentUser && currentUser.username != "") {
            let domain = currentUser.username.substring(currentUser.username.lastIndexOf("@") +1);
            if (domain == "identakid.com") {
                this.services.push({id: 'admin', title: 'Admin'})
            }
        }
    }

    ngOnInit() {
        let titleStr = 'Add New';

		this.acctNumber = this.activatedRoute.snapshot.params['acctNumber'];
        this.idParam = this.activatedRoute.snapshot.params['id'];
        if (this.acctNumber != null) {
            this.idsvc.validateAcctNumber(this.acctNumber)
                .subscribe(res => {
                    if (!res) {
                        this.msgHead.error(`You don't have access to this district number ${this.acctNumber}`);
                        this.hasAccess = false;
                    }
                }, err => {
                    console.log(err);
                    let e = this.idsvc.getUserErrorDefault(err);
                    this.msgHead.error(e);
                    this.hasAccess = false;
                })
        }

        this.idsvc.findIdPApi(this.acctNumber, new FindIdP())
            .subscribe((rows: IdP[]) => {
                for (let idp of rows) {
                    this.idps.push({ id: idp.id.toString(), title: idp.name });
                }
            }, err => {
                console.log(err);
                if (this.idsvc.isErrNotFound(err)) {
                this.msg.warning(this.idsvc.getUserError(err));
                } else {
                if (this.idsvc.isErrUnauthorized(err)) {
                    this.hasAccess = false;
                    this.msg.error(this.idsvc.getUserErrorDefault(err));
                } else {
                    this.msg.error(this.idsvc.getUserErrorDefault(err));
                }
                }
            });

        if (this.idParam) {
			this.editMode = true;
			this.loadData();
			titleStr = 'Edit';
		}

        this.title.setTitles({
            title: `${titleStr} - Roles Mapping`,
            dashboard: `${titleStr} - Roles Mapping`
        });
        this.title.setBreadcrumbs([
            { title: 'Roles Mapping ', link: `/idp/${this.acctNumber}/roles-mapping` },
            { title: titleStr, link: `` }
        ]);
    }

    loadData() {
        let find = new FindIdPRolesMapping();
		find.id = parseInt(this.idParam);
		this.idsvc.findIdPRolesMappingApi(this.acctNumber, find)
			.subscribe((rows: IdPRolesMapping[]) => {
				this.msg.close();
                this.data = rows[0];
                this.loadOrgs();
				this.form.get('idpId').setValue(this.data.idpId.toString());
                this.form.get('serviceId').setValue(this.data.serviceId);
				this.form.get('accountGroups').setValue(this.data.accountGroups);
                this.form.get('serviceRolesGroups').setValue(this.data.serviceRolesGroups);
				this.form.get('orgAcctNumber').setValue(this.data.orgAcctNumber.toString());
                this.loadServiceRoles();
            }, err => {
				console.log(err);
				if (this.idsvc.isErrNotFound(err)) {
					this.msg.warning(this.idsvc.getUserError(err));
				} else {
					if (this.idsvc.isErrUnauthorized(err)) {
						this.hasAccess = false;
						this.msg.error(this.idsvc.getUserErrorDefault(err));
					} else {
						this.msg.error(this.idsvc.getUserErrorDefault(err));
					}
				}
			});
    }

    displayServiceRoles() {
        this.hideOrgInput = false;
        this.form.get('orgAcctNumber').setValue('');
        this.serviceRoles = [];
        this.loadOrgs();
        switch(this.data.serviceId) {
        case 'school':
            this.serviceRoles = this.schoolManagerRoles;
            break;
        case 'district':
            this.serviceRoles = this.districtMangerRoles;
            break;
        case 'identity':
            this.serviceRoles = this.identityRoles;
            break;
        case 'admin':
            this.serviceRoles = this.adminRoles;
            break;
		}
    }

    loadServiceRoles() {
        let roles = this.data.serviceRoles.split(',');
        switch(this.data.serviceId) {
        case 'school':
            for (let r of this.schoolManagerRoles) {
                for (let role of roles) {
                    if (r.title == role) {
                        r.value = true;
                    }
                }
            }
            this.serviceRoles = this.schoolManagerRoles;
            break;
        case 'district':
            for (let r of this.districtMangerRoles) {
                for (let role of roles) {
                    if (r.title == role) {
                        r.value = true;
                    }
                }
            }
            this.serviceRoles = this.districtMangerRoles;
            break;
        case 'identity':
            for (let r of this.identityRoles) {
                for (let role of roles) {
                    if (r.title == role) {
                        r.value = true;
                    }
                }
            }
            this.serviceRoles = this.identityRoles;
            break;
        case 'admin':
            for (let r of this.adminRoles) {
                for (let role of roles) {
                    if (r.title == role) {
                        r.value = true;
                    }
                }
            }
            this.serviceRoles = this.adminRoles;
            break;
		}
    }

    loadOrgs() {
        this.orgs = [];
        this.orgs.push({ id: '', title: 'Select Organization' });
        if (this.data.serviceId == 'admin') {
            this.form.get('orgAcctNumber').setValue('0');
            this.hideOrgInput = true;
            return;
        }
        let find = new FindAccountAssociation();
        if (this.data.serviceId == 'district' || this.data.serviceId == 'identity') {
            this.idsvc.userRolesApi().subscribe((urs: UserRoles[]) => {
                for (let ur of urs) {
                    if (this.acctNumber == ur.acctNumber) {
                        this.orgs.push({ id: this.hexToInt(ur.acctNumber).toString(), title: ur.schoolName });
                    }
                }
            }, err => {
                this.msg.error(this.idsvc.getUserErrorDefault(err));
                console.log(err);
            });
            return;
        }
        if (this.data.serviceId == 'school') {
            this.orgs.push({ id: '10', title: 'All' });
        }
        find.enabled = true;
        this.idsvc.findAccountAssociation(this.acctNumber, find).subscribe((accs: AccountAssociation[]) => {
            this.msg.close();
            for (let acc of accs) {
                this.orgs.push({ id: acc.acctNumber.toString(), title: acc.organizationName });
            }
        }, err => {
            console.log(err);
            if (this.idsvc.isErrNotFound(err)) {
                this.msg.warning(this.idsvc.getUserError(err));
            } else {
                if (this.idsvc.isErrUnauthorized(err)) {
                    this.hasAccess = false;
                    this.msg.error(this.idsvc.getUserErrorDefault(err));
                } else {
                    this.msg.error(this.idsvc.getUserErrorDefault(err));
                }
            }
        });
    }

    save() {
        this.msg.error('');
        if (!this.form.valid) {
			this.displayErrors(this.form);
			return;
        }
        this.data.idpId = parseInt(this.form.get('idpId').value);
        this.data.serviceId = this.form.get('serviceId').value;
        this.data.orgAcctNumber = parseInt(this.form.get('orgAcctNumber').value)
        this.data.accountGroups = this.form.get('accountGroups').value;
        this.data.serviceRolesGroups = this.form.get('serviceRolesGroups').value;
        let selectedRoles: string[] = [];
        for (let role of this.serviceRoles) {
            if (role.value) {
                selectedRoles.push(role.title)
            }
        }
        if (selectedRoles.length == 0) {
            this.msg.error("select at least one role")
            return;
        }
        this.data.serviceRoles = selectedRoles.join();
        if (this.editMode) {
            this.idsvc.updateIdPRolesMappingApi(this.acctNumber, this.data)
			.subscribe(res => {
                this.router.navigate([`idp/${this.acctNumber}/roles-mapping`]);
                return;
            }, err => {
                console.log(err);
                let e = this.idsvc.getUserErrorDefault(err);
                this.msgHead.error(e);
            });
        } else {
            this.idsvc.addIdPRolesMappingApi(this.acctNumber, this.data)
                .subscribe(res => {
                    this.router.navigate([`idp/${this.acctNumber}/roles-mapping`]);
                    return;
                }, err => {
                    console.log(err);
                    let e = this.idsvc.getUserErrorDefault(err);
                    this.msgHead.error(e);
                });
        }
    }

    displayErrors(f: FormGroup) {
		var message = '';
		controlErrors(f, (c: any, err: any) => {
			message += err + '<br>';
		});
		this.msg.errorHtml(message);
	}

    goBack() {
		this.router.navigate([`idp/${this.acctNumber}/roles-mapping`]);
		return;
    }

    hexToInt(hex) {
		if (hex.length % 2 != 0) {
			hex = "0" + hex;
		}
		var num = parseInt(hex, 16);
		var maxVal = Math.pow(2, hex.length / 2 * 8);
		if (num > maxVal / 2 - 1) {
			num = num - maxVal
		}
		return num;
	}

}
